module.exports = __webpack_public_path__ + "img/B低通锐化3.5bf142a3.png";